<template>
  <div
    class="m-5 md:m-15 2xl:m-20"
    @click="calculate_progress"
    @keyup="progressbar.userKeyUp()"
    @keydown="progressbar.userKeyDown()"
  >
    <h3 id="form-intitule" class="mb-15 2xl:mb-20 w-full">
      Identification du titulaire
    </h3>

    <!-- BEGIN Identification du titulaire -->
    <div class="grid grid-cols-12 gap-x-4 gap-y-10">
      <input-text
        :necessary="true"
        :value="form.prenom == null ? infosPass.firstname : form.prenom"
        class="md:col-span-3"
        libelle="Prénom"
        name="prenom"
        @input="
          (newValue) => {
            form.prenom = newValue;
          }
        "
        :error="form.prenom.length === 0"
        :msg-error="((errors || [])['data.prenom'] || [])[0]"
      />

      <input-text
        :necessary="true"
        :value="form.nom == null ? infosPass.lastname : form.nom"
        class="md:col-span-3"
        libelle="Nom"
        name="nom"
        @input="
          (newValue) => {
            form.nom = newValue;
          }
        "
        :error="form.nom.length === 0"
        :msg-error="((errors || [])['data.nom'] || [])[0]"
      />

      <date-picker
        :necessary-date="true"
        :value="form.date_naissance"
        class="col-span-full md:col-span-3"
        direction="left"
        format="dd/MM/yyyy"
        initialview="year"
        libelle="Date de naissance"
        name="date_naissance"
        @input="
          (newValue) => {
            form.date_naissance = newValue;
          }
        "
      />

      <input-select
        :datas="[
          { value: 'Femme' },
          { value: 'Homme' },
          { value: 'Non-binaire' },
        ]"
        :necessary="true"
        :value="form.genre"
        class="md:col-span-3"
        libelle="Genre"
        name="genre"
        @input="
          (newValue) => {
            form.genre = newValue;
          }
        "
      />

      <input-select
        :datas="[
          { value: 'Célibataire' },
          { value: 'Marié(e)' },
          { value: 'Veuf(ve)' },
          { value: 'Séparé(e)' },
          { value: 'Divorcé(e)' },
          { value: 'PACS' },
          { value: 'Concubinage' },
        ]"
        :necessary="true"
        :value="form.situation"
        class="md:col-span-3"
        libelle="Situation familliale"
        name="situation"
        @input="
          (newValue) => {
            form.situation = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.telephone"
        type="tel"
        :error="true"
        class="md:col-span-3"
        libelle="Téléphone"
        name="telephone"
        @input="
          (newValue) => {
            form.telephone = newValue;
          }
        "
        :msg-error="((errors || [])['data.telephone'] || [])[0]"
        @focusInput="errors['data.telephone'] = []"
      />

      <input-text
        :necessary="true"
        :value="form.email"
        class="md:col-span-3"
        libelle="Email"
        name="email"
        type="email"
        @input="
          (newValue) => {
            form.email = newValue;
          }
        "
        :error="true"
        :msg-error="((errors || [])['data.email'] || [])[0]"
        @focusInput="errors['data.email'] = []"
      />

      <input-text
        :necessary="true"
        :value="form.website"
        class="md:col-span-3"
        libelle="Site internet personnel"
        name="website"
        type="text"
        @input="
          (newValue) => {
            form.website = newValue;
          }
        "
      />

      <input-text-area
        :necessary="true"
        :size="5"
        :value="form.adresse"
        class="md:col-span-6"
        libelle="Adresse complète"
        name="adresse"
        @input="
          (newValue) => {
            form.adresse = newValue;
          }
        "
      />

      <input-select
        :datas="[
          { value: 'Structure Hébergement' },
          { value: 'Appartement Collectif' },
          { value: 'Famille' },
          { value: 'Famille d\'accueil' },
          { value: 'Logement personnel avec accompagnement (type SAVS)' },
          { value: 'Logement personnel sans accompagnement' },
          { value: 'Autres (hôpital, sans domicile...)' },
        ]"
        :necessary="true"
        :value="form.hebergement"
        class="md:col-span-3"
        libelle="Hébergement"
        name="hebergement"
        @input="
          (newValue) => {
            form.hebergement = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.hebergement === 'Autres (hôpital, sans domicile...)'"
          :necessary="true"
          :value="form.hebergement_precis"
          class="md:col-span-3"
          libelle="Autre hébergement"
          name="hebergement_precis"
          @input="
            (newValue) => {
              form.hebergement_precis = newValue;
            }
          "
        />
      </transition>

      <input-select
        :datas="[
          { value: 'Aucun' },
          { value: 'Niveau 3 - CAP, BEP' },
          { value: 'Niveau 4 - Baccalauréat' },
          { value: 'Niveau 5 - DEUG, BTS, DUT, DEUST' },
          {
            value:
              'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1',
          },
          {
            value:
              'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur',
          },
          {
            value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches',
          },
          { value: 'Autre' },
        ]"
        :necessary="true"
        :value="form.niveau"
        class="lg:col-start-1 md:col-span-3"
        libelle="Niveau de formation"
        name="niveau"
        @input="
          (newValue) => {
            form.niveau = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.niveau === 'Autre'"
          :necessary="true"
          :value="form.niveau_precis"
          class="md:col-span-3"
          libelle="Autre niveau de formation"
          name="niveau_precis"
          @input="
            (newValue) => {
              form.niveau_precis = newValue;
            }
          "
        />
      </transition>

      <input-text
        :necessary="false"
        :value="form.dernier_diplome"
        class="md:col-span-3"
        libelle="Dernier diplôme obtenu"
        name="dernier_diplome"
        @input="
          (newValue) => {
            form.dernier_diplome = newValue;
          }
        "
      />

      <multiple-select
        :datas="[
          { value: 'Aucun' },
          { value: 'Voiture' },
          { value: 'Moto' },
          { value: 'Scooter' },
          { value: 'Vélo' },
          { value: 'Marche' },
          { value: 'Train' },
          { value: 'Bus' },
          { value: 'Transports en commun' },
          { value: 'Autres' },
        ]"
        :necessary="true"
        :value="form.moyen_transport"
        class="lg:col-start-1 md:col-span-3"
        libelle="Moyen de déplacement"
        name="moyen_transport"
        @input="
          (newValue) => {
            form.moyen_transport = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.moyen_transport.includes('Autres')"
          :necessary="true"
          :value="form.moyen_transport_precis"
          class="md:col-span-3"
          libelle="Autre moyen de transport"
          name="moyen_transport_precis"
          @input="
            (newValue) => {
              form.moyen_transport_precis = newValue;
            }
          "
        />
      </transition>

      <multiple-select
        :datas="[
          { value: 'ASSR1' },
          { value: 'ASSR2' },
          { value: 'BSR' },
          { value: 'A' },
          { value: 'A1' },
          { value: 'B' },
          { value: 'B1' },
          { value: 'C' },
          { value: 'D' },
          { value: 'E' },
          { value: 'Autres' },
        ]"
        :necessary="false"
        :value="form.permis"
        class="md:col-span-3"
        libelle="Permis de conduire"
        name="permis"
        @input="
          (newValue) => {
            form.permis = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.permis.includes('Autres')"
          :necessary="false"
          :value="form.permis_precis"
          class="md:col-span-3"
          libelle="Autre permis"
          name="permis_precis"
          @input="
            (newValue) => {
              form.permis_precis = newValue;
            }
          "
        />
      </transition>

      <multiple-select
        :datas="[
          { value: 'Aucun' },
          { value: 'Salaire' },
          { value: 'ARE' },
          { value: 'AAH' },
          { value: 'RSA' },
          { value: 'ASS' },
          { value: 'Pension invalidité' },
          { value: 'Autres' },
        ]"
        :necessary="true"
        :value="form.type_revenus"
        class="lg:col-start-1 md:col-span-3"
        libelle="Type de revenus"
        name="type_revenus"
        @input="
          (newValue) => {
            form.type_revenus = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.type_revenus.includes('Autres')"
          :necessary="true"
          :value="form.type_revenus_precis"
          class="md:col-span-3"
          libelle="Autre type de revenus"
          name="type_revenus_precis"
          @input="
            (newValue) => {
              form.type_revenus_precis = newValue;
            }
          "
        />
      </transition>

      <input-select
        :datas="[{ value: 'Oui' }, { value: 'Non' }]"
        :necessary="true"
        :value="form.titre_sejour"
        class="md:col-span-3"
        libelle="Carte de séjour"
        name="titre_sejour"
        @input="
          (newValue) => {
            form.titre_sejour = newValue;
          }
        "
      />
    </div>
    <!-- END Identification du titulaire -->

    <!-- BEGIN Informations générales -->
    <h3 id="form-infos-generales" class="my-16 xxl:my-20 2xl:my-22">
      Informations générales
    </h3>

    <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
      <!-- BEGIN Reconnaissance handicap -->
      <checkbox-indigo
        :is-checkbox-right="true"
        :value="form.travailleur_handicape"
        class="col-span-full md:col-span-6 place-self-start"
        libelle="Etes-vous reconnu comme travailleur handicapé ?"
        name="travailleur_handicape"
        @input="
          (newValue) => {
            form.travailleur_handicape = newValue;
          }
        "
      />
      <transition
        enter-active-class="duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
      >
        <div v-if="form.travailleur_handicape" class="col-span-full">
          <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
            <div class="col-span-full md:col-span-6 flex">
              <multiple-select
                :datas="[
                  {
                    value:
                      'Handicap Intellectuel et difficultés de comportement',
                  },
                  { value: 'Handicap psychique' },
                  { value: 'Handicap du Langage et de la Parole' },
                  { value: 'Handicap Auditif' },
                  { value: 'Handicap Visuel' },
                  { value: 'Handicap Viscéral et général' },
                  { value: 'Handicap Moteur et troubles associés' },
                  { value: 'Maladies invalidantes' },
                  { value: 'Trouble du spectre de l\'autisme (TSA)' },
                  { value: 'Autres handicaps' },
                  { value: 'Je ne souhaite pas le spécifier' },
                ]"
                :necessary="true"
                :value="form.handicap"
                libelle="Type de handicap"
                name="handicap"
                @input="
                  (newValue) => {
                    form.handicap = newValue;
                  }
                "
              />
            </div>

            <div class="col-span-full md:col-span-6 flex">
              <input-select
                :datas="[{ value: 'Oui' }, { value: 'Non' }]"
                :necessary="true"
                :value="form.lourdeur_handicap"
                label-libelle="Procédure qui a pour but de mesurer l'incidence du handicap sur la capacité de travail de la personne handicapée après un aménagement optimal de son poste de travail. La reconnaissance de la lourdeur du handicap permet de compenser l'effort réalisé par l'employeur pour l'adaptation du poste de travail, par l'attribution d'une minoration de la contribution due au titre de l'obligation d'emploi ou d'une aide a l'emploi. Depuis le 1er juillet 2011, c’est l'Association de gestion du fonds pour l'insertion professionnelle des personnes handicapées (AGEFIPH) qui gère ce dispositif d’attribution de la lourdeur du handicap (Loi de finances 2011)."
                libelle="Reconnaissance lourdeur de handicap"
                name="lourdeur_handicap"
                @input="
                  (newValue) => {
                    form.lourdeur_handicap = newValue;
                  }
                "
              />
            </div>
            <transition
              enter-active-class="ease-in duration-300"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="ease-out duration-300"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <input-text
                v-if="form.handicap.includes('Autres handicaps')"
                :necessary="true"
                :value="form.handicap_precis"
                class="md:col-span-6"
                libelle="Autre handicap"
                name="handicap_precis"
                @input="
                  (newValue) => {
                    form.handicap_precis = newValue;
                  }
                "
              />
            </transition>
          </div>
          <!-- BEGIN list type reconnaissance -->
          <div
            v-for="(type, i_t) in form.type_reconnaissance"
            :key="i_t"
            class="transition-all duration-300 flex items-center justify-center my-10"
          >
            <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
              <div class="col-span-full md:col-span-6 flex space-x-4">
                <delete-button
                  class="pt-6 md:pt-7"
                  @del="deleteItem(form.type_reconnaissance, i_t)"
                />
                <input-select
                  :datas="[
                    { value: 'Aucune' },
                    {
                      value:
                        'Reconnaissance travailleur handicapé délivrée par la CDAPH',
                    },
                    {
                      value:
                        'Titulaire d\'une rente d\'accident du travail ou d\'une maladie professionnelle',
                    },
                    { value: 'Titulaire d\'une pension d\'invalidité' },
                    { value: 'Pensionné de guerre ou assimilé' },
                    { value: 'Titulaire de l\'allocation adulte handicapé' },
                    { value: 'Titulaire de la carte d\'invalidité' },
                    {
                      value:
                        'Autre catégorie (Mutilé de guerre, assimilé mutilé de guerre, sapeur pompier volontaire)',
                    },
                  ]"
                  :name="'statut' + i_t"
                  :necessary="true"
                  :value="type.statut"
                  class="mr-4 flex-shrink flex-initial"
                  libelle="Type de reconnaissance"
                  @input="
                    (newValue) => {
                      type.statut = newValue;
                    }
                  "
                />
              </div>

              <!-- BEGIN Only for desktop -->
              <div class="hidden lg:flex col-start-auto col-span-6">
                <input-text
                  :name="'cdaph' + i_t"
                  :necessary="true"
                  :value="type.cdaph"
                  class="mr-4 flex-shrink flex-initial"
                  label-libelle="Les Commissions des Droits et de l’Autonomie des Personnes Handicapées (CDAPH) ont été créées par la loi n°2005-102 du 11 février 2005 pour 'l’égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées'. Elles résultent de la fusion des Commissions techniques d’orientation et de reclassement professionnel (COTOREP) et des Commissions départementales d’éducation spéciale (CDES)"
                  libelle="Numéro de dossier"
                  @input="
                    (newValue) => {
                      type.cdaph = newValue;
                    }
                  "
                />

                <date-picker
                  :name="'cdaph_validite' + i_t"
                  :necessary-date="true"
                  :value="type.cdaph_validite"
                  direction="left"
                  format="dd/MM/yyyy"
                  initialview="year"
                  libelle="Fin de validité"
                  @input="
                    (newValue) => {
                      type.cdaph_validite = newValue;
                    }
                  "
                />
              </div>
              <!-- END Only for desktop -->
              <!-- BEGIN Only for mobile devices -->
              <input-text
                :name="'cdaph' + i_t"
                :necessary="true"
                :value="type.cdaph"
                class="lg:hidden col-span-full"
                label-libelle="Les Commissions des Droits et de l’Autonomie des Personnes Handicapées (CDAPH) ont été créées par la loi n°2005-102 du 11 février 2005 pour 'l’égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées'. Elles résultent de la fusion des Commissions techniques d’orientation et de reclassement professionnel (COTOREP) et des Commissions départementales d’éducation spéciale (CDES)"
                libelle="Numéro de dossier"
                @input="
                  (newValue) => {
                    type.cdaph = newValue;
                  }
                "
              />

              <date-picker
                :name="'cdaph_validite' + i_t"
                :necessary-date="true"
                :value="type.cdaph_validite"
                class="lg:hidden col-span-full"
                direction="left"
                format="dd/MM/yyyy"
                initialview="year"
                libelle="Fin de validité"
                @input="
                  (newValue) => {
                    type.cdaph_validite = newValue;
                  }
                "
              />
              <!-- END Only for mobile devices -->
            </div>
          </div>
          <!-- END list type reconnaissance -->

          <!-- BEGIN Button to add a "type de reconnaissance" -->
          <add-button
            class="my-10"
            libelle="Ajouter un type de reconnaissance"
            @add="addTypeReconnaissance()"
          />
          <!-- END Button to add a "type de reconnaissance" -->

          <!-- BEGIN Tutelle ou curatelle -->
          <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <input-select
              :datas="[{ value: 'Oui' }, { value: 'Non' }]"
              :necessary="true"
              :value="form.tutelle"
              class="lg:col-start-1 col-span-full md:col-span-6"
              label-libelle="<div class='block'>La Tutelle : <div><ul class='list-inside list-disc'><li>Pour les majeurs : Mesure judiciaire destinée à protéger une personne majeure et/ou tout ou partie de son patrimoine si elle n'est plus en état de veiller sur ses propres intérêts. Un tuteur la représente dans les actes de la vie civile. Le juge peut énumérer, à tout moment, les actes que la personne peut faire seule ou non, au cas par cas.</li><li>Pour les mineurs : Lorsque les titulaires de l'autorité parentale ne peuvent plus l'exercer, une tutelle est ouverte pour les enfants mineurs. Le juge constitue un conseil de famille qui nomme un tuteur et un subrogé tuteur.</li></ul>"
              libelle="Tutelle ou Curatelle"
              name="tutelle"
              @input="
                (newValue) => {
                  form.tutelle = newValue;
                }
              "
            />

            <transition
              enter-active-class="duration-300"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
            >
              <div
                v-if="form.tutelle === 'Oui'"
                class="md:col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
              >
                <input-select
                  :datas="[
                    { value: 'Tutelle' },
                    { value: 'Curatelle simple' },
                    { value: 'Curatelle renforcée' },
                    { value: 'Autre' },
                  ]"
                  :necessary="true"
                  :value="form.tutelle_precis"
                  class="md:col-span-4"
                  label-libelle="<ul class='list-inside list-disc'><li><div class='inline-block font-medium'>La curatelle simple :</div>
                                Mesure judiciaire destinée à protéger une personne majeure qui, sans être hors d'état d'agir elle-même, a besoin d'être conseillée ou contrôlée d'une manière continue dans les actes importants de la vie civile. La curatelle n'est prononcée que s'il est établi que la mesure de sauvegarde de justice serait une protection insuffisante pour la personne.</li>
                                <li><div class='inline-block font-medium'>La curatelle renforcée :</div>
                                Basée sur l'article 472 du code civil, elle renforce les pouvoirs du curateur. En plus des pouvoirs attribués dans le cadre de la curatelle simple au curateur, ce dernier percevra seul les revenus de la personne protégée et assurera lui-même à l'égard des tiers le règlement de ses dépenses. Cette formule se rapproche un peu plus du système de la tutelle, tout en demeurant plus souple.</li></ul>"
                  libelle="Précisez"
                  name="tutelle_precis"
                  @input="
                    (newValue) => {
                      form.tutelle_precis = newValue;
                    }
                  "
                />

                <transition
                  enter-active-class="ease-in duration-300"
                  enter-class="opacity-0"
                  leave-active-class="ease-out duration-300"
                  leave-to-class="opacity-0"
                >
                  <input-text
                    v-if="form.tutelle_precis === 'Autre'"
                    :necessary="true"
                    :value="form.tutelle_autre"
                    class="md:col-span-4"
                    libelle="Autre"
                    name="tutelle_autre"
                    @input="
                      (newValue) => {
                        form.tutelle_autre = newValue;
                      }
                    "
                  />
                </transition>

                <input-text
                  :necessary="true"
                  :value="form.tutelle_personne"
                  class="md:col-span-4"
                  libelle="Personne ou organisme"
                  name="tutelle_personne"
                  @input="
                    (newValue) => {
                      form.tutelle_personne = newValue;
                    }
                  "
                />
              </div>
            </transition>
          </div>
          <!-- END tutelle ou curatelle -->
        </div>
      </transition>
      <!-- END Reconnaissance handicap -->

      <input-text
        :necessary="true"
        :value="form.organisme_prescripteur"
        class="lg:col-start-1 md:col-span-4"
        libelle="Organisme prescripteur"
        name="organisme_prescripteur"
        @input="
          (newValue) => {
            form.organisme_prescripteur = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.nom_referent"
        class="md:col-span-4"
        libelle="Nom du référent"
        name="nom_referent"
        @input="
          (newValue) => {
            form.nom_referent = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.tel_referent"
        type="tel"
        :error="true"
        class="md:col-span-4"
        libelle="Tél"
        name="tel_referent"
        @input="
          (newValue) => {
            form.tel_referent = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.organisme_social"
        class="md:col-span-4"
        label-libelle="Organisme référent social ou socioprofessionnel (Cap Emploi, Pôle Emploi, SAVS...)"
        libelle="Organisme référent"
        name="organisme_social"
        @input="
          (newValue) => {
            form.organisme_social = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.nom_referent_social"
        class="md:col-span-4"
        libelle="Nom du référent"
        name="nom_referent_social"
        @input="
          (newValue) => {
            form.nom_referent_social = newValue;
          }
        "
      />

      <input-text
        :necessary="true"
        :value="form.tel_referent_social"
        type="tel"
        :error="true"
        class="md:col-span-4"
        libelle="Tél"
        name="tel_referent_social"
        @input="
          (newValue) => {
            form.tel_referent_social = newValue;
          }
        "
      />

      <input-select
        :datas="[
          { value: 'Scolarisation' },
          { value: 'Formation initiale' },
          { value: 'Activité professionnelle' },
          { value: 'En recherche d\'emploi' },
          { value: 'Autre' },
        ]"
        :necessary="true"
        :value="form.situation_emploi"
        class="lg:col-start-1 md:col-span-6 col-span-full"
        libelle="Situation actuelle par rapport à l'emploi"
        name="situation_emploi"
        @input="
          (newValue) => {
            form.situation_emploi = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.situation_emploi === 'Autre'"
          :necessary="true"
          :value="form.situation_emploi_precis"
          class="md:col-span-6"
          libelle="Autre situation par rapport à l'emploi"
          name="situation_emploi_precis"
          @input="
            (newValue) => {
              form.situation_emploi_precis = newValue;
            }
          "
        />
      </transition>

      <div class="col-span-full flex items-end space-x-4">
        <checkbox-indigo
          :is-checkbox-right="true"
          :value="form.pole_emploi"
          class="w-6/12"
          libelle="Etes-vous inscrit à Pôle Emploi ?"
          name="pole_emploi"
          @input="
            (newValue) => {
              form.pole_emploi = newValue;
            }
          "
        />
        <div class="w-6/12 md:w-3/12">
          <transition
            enter-active-class="ease-in duration-300"
            enter-class="opacity-0"
            leave-active-class="ease-out duration-300"
            leave-to-class="opacity-0"
          >
            <input-text
              v-if="form.pole_emploi"
              :necessary="true"
              :value="form.numero_pole_emploi"
              class=""
              libelle="N° demandeur d'emploi"
              name="numero_pole_emploi"
              @input="
                (newValue) => {
                  form.numero_pole_emploi = newValue;
                }
              "
            />
          </transition>
        </div>
      </div>
      <input-text
        :necessary="true"
        :value="form.emploi"
        class="lg:col-start-1 md:col-span-4 col-span-full"
        libelle="Emploi (ou projet professionnel)"
        name="emploi"
        @input="
          (newValue) => {
            form.emploi = newValue;
          }
        "
      />
      <input-text
        :necessary="true"
        :value="form.structure"
        class="md:col-span-4"
        libelle="Nom de la structure actuelle"
        name="structure"
        @input="
          (newValue) => {
            form.structure = newValue;
          }
        "
      />

      <date-picker
        :necessary-date="true"
        :value="form.date_structure"
        class="col-span-full md:col-span-4"
        direction="left"
        format="dd/MM/yyyy"
        initialview="year"
        libelle="Date d'entrée dans la structure"
        name="date_structure"
        width="t23"
        @input="
          (newValue) => {
            form.date_structure = newValue;
          }
        "
      />

      <input-select
        :class="
          'lg:col-start-1 ' +
          (form.situation_anterieure === 'Autre'
            ? 'md:col-span-3'
            : 'md:col-span-6')
        "
        :datas="[
          { value: 'Demandeur d\'Emploi' },
          { value: 'Scolarité classique ou Formation' },
          {
            value:
              'Institution ou Service Spécialisé (IME, SIPFP, IES, IEM...)',
          },
          { value: 'Service d\'Accompagnement Social (SSAD, SESSAD, SAVS...)' },
          { value: 'Etablissement et Service d\'Aide par le Travail (ESAT)' },
          { value: 'Entreprise Adaptée (EA)' },
          { value: 'Centre de Distribution de Travail à Domicile (CDTD)' },
          { value: 'Entreprise d\'Insertion (EI)' },
          { value: 'Entreprise de Travail Temporaire (ETT, ETTI)' },
          { value: 'Milieu Ordinaire / Handicap' },
          { value: 'Milieu Ordinaire / Inaptitude' },
          {
            value: 'Institution Sanitaire (CHR, CHS, CRF...) / Hospitalisation',
          },
          { value: 'Autre' },
        ]"
        :necessary="true"
        :value="form.situation_anterieure"
        libelle="Situation antérieure à l'entrée dans la structure"
        name="situation_anterieure"
        @input="
          (newValue) => {
            form.situation_anterieure = newValue;
          }
        "
      />

      <transition
        enter-active-class="ease-in duration-300"
        enter-class="opacity-0"
        leave-active-class="ease-out duration-300"
        leave-to-class="opacity-0"
      >
        <input-text
          v-if="form.situation_anterieure === 'Autre'"
          :necessary="true"
          :value="form.situation_anterieure_precis"
          class="md:col-span-3"
          libelle="Autre situation antérieure"
          name="situation_anterieure_precis"
          @input="
            (newValue) => {
              form.situation_anterieure_precis = newValue;
            }
          "
        />
      </transition>

      <input-text
        :necessary="true"
        :value="form.referent"
        class="md:col-span-6"
        libelle="Référent (ou responsable hiérarchique)"
        name="referent"
        @input="
          (newValue) => {
            form.referent = newValue;
          }
        "
      />

      <input-text-area
        :necessary="true"
        :size="5"
        :value="form.conditions1"
        class="col-span-full md:col-span-6 lg:col-start-1"
        libelle="Conditions de travail recherchées (préconisation)"
        name="conditions1"
        @input="
          (newValue) => {
            form.conditions1 = newValue;
          }
        "
      />
      <input-text-area
        :necessary="true"
        :size="5"
        :value="form.conditions2"
        class="col-span-full md:col-span-6"
        libelle="Recommandations et propositions de mesures individuelles"
        name="conditions2"
        @input="
          (newValue) => {
            form.conditions2 = newValue;
          }
        "
      />
    </div>
    <!-- END Informations générales -->

    <h3 id="form-contacts" class="my-16 xxl:my-20 2xl:my-22 w-full">
      Personnes à contacter <br />en cas d'urgence
    </h3>

    <!-- BEGIN Personnes à contacter -->
    <div v-if="form.proches.length > 0">
      <!-- to refresh list when remove last item (reset values because non reactive element) -->
      <div
        v-for="(proche, index) in form.proches"
        :key="index"
        class="transition-all duration-300 flex flex-col space-y-10 mb-10"
      >
        <div class="grid grid-cols-10 gap-x-4 gap-y-10 w-full">
          <div class="col-span-10 md:col-span-4 flex space-x-4">
            <delete-button
              class="pt-6 lg:pt-7"
              @del="deleteItem(form.proches, index)"
            />
            <input-text
              :name="'prenom_proche' + index"
              :necessary="true"
              :value="proche.prenom_proche"
              libelle="Prénom"
              @input="
                (newValue) => {
                  proche.prenom_proche = newValue;
                }
              "
            />
          </div>

          <input-text
            :name="'nom_proche' + index"
            :necessary="true"
            :value="proche.nom_proche"
            class="md:col-span-3"
            libelle="Nom"
            @input="
              (newValue) => {
                proche.nom_proche = newValue;
              }
            "
          />
          <div class="col-span-full md:col-span-3 grid grid-cols-2 gap-x-4">
            <input-select
              :class="
                proche.relation_proche === 'Autre'
                  ? 'md:col-span-1'
                  : 'md:col-span-full'
              "
              :datas="[
                { value: 'Conjoint(e)' },
                { value: 'Parent' },
                { value: 'Famille' },
                { value: 'Autre' },
              ]"
              :name="'relation_proche' + index"
              :necessary="true"
              :value="proche.relation_proche"
              libelle="Relation"
              width="t30"
              @input="
                (newValue) => {
                  proche.relation_proche = newValue;
                }
              "
            />

            <transition
              enter-active-class="ease-in duration-300"
              enter-class="opacity-0"
              leave-active-class="ease-out duration-300"
              leave-to-class="opacity-0"
            >
              <input-text
                v-if="proche.relation_proche === 'Autre'"
                :necessary="true"
                :value="proche.relation_proche_precis"
                class="md:col-span-1"
                libelle="Autre relation"
                name="relation_proche_precis"
                @input="
                  (newValue) => {
                    proche.relation_proche_precis = newValue;
                  }
                "
              />
            </transition>
          </div>
          <input-text-area
            :name="'adresse_proche' + index"
            :necessary="true"
            :size="5"
            :value="proche.adresse_proche"
            class="md:col-span-4"
            libelle="Adresse complète"
            @input="
              (newValue) => {
                proche.adresse_proche = newValue;
              }
            "
          />

          <input-text
            :name="'telephone_proche' + index"
            :necessary="true"
            :value="proche.telephone_proche"
            class="md:col-span-3"
            libelle="Téléphone"
            @input="
              (newValue) => {
                proche.telephone_proche = newValue;
              }
            "
            :error="true"
            type="tel"
          />

          <input-text
            :name="'mail_proche' + index"
            :necessary="true"
            :value="proche.mail_proche"
            class="md:col-span-3"
            libelle="Mail"
            type="email"
            width="t25"
            @input="
              (newValue) => {
                proche.mail_proche = newValue;
              }
            "
            :error="true"
          />
        </div>
        <div
          v-if="index < form.proches.length - 1"
          class="w-full border-b border-gray-600"
        />
      </div>
    </div>
    <!-- END Personnes à contacter -->

    <!-- BEGIN Button to add a "proche" -->
    <add-button libelle="Ajouter un contact" @add="addProche()" />
    <!-- END Button to add a "proche" -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxIndigo from '../../../components/Inputs/CheckboxIndigo';
import AddButton from './../../../components/Inputs/AddButton';
import DeleteButton from './../../../components/Inputs/DeleteButton';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxIndigo,
    AddButton,
    DeleteButton,
  },

  props: ['progressbar'],

  name: 'InformationsGenerales',

  data() {
    return {
      // Initial state of the form
      form: {
        prenom: '',
        nom: '',
        date_naissance: '',
        genre: '',
        hebergement: '',
        hebergement_precis: '',
        situation: '',
        telephone: '',
        email: '',
        adresse: '',
        moyen_transport: [],
        moyen_transport_precis: '',
        permis: [],
        permis_precis: '',
        niveau: '',
        niveau_precis: '',
        dernier_diplome: '',
        type_revenus: [],
        type_revenus_precis: '',
        titre_sejour: '',
        travailleur_handicape: false,
        handicap: [],
        handicap_precis: '',
        lourdeur_handicap: '',
        lourdeur_handicap_cv: '',
        type_reconnaissance: [],
        tutelle: '',
        tutelle_cv: '',
        tutelle_precis: '',
        tutelle_autre: '',
        tutelle_personne: '',
        organisme_prescripteur: '',
        nom_referent: '',
        tel_referent: '',
        organisme_social: '',
        nom_referent_social: '',
        tel_referent_social: '',
        situation_emploi: '',
        situation_emploi_precis: '',
        pole_emploi: false,
        numero_pole_emploi: '',
        emploi: '',
        emploi_cv: false,
        structure: '',
        date_structure: '',
        situation_anterieure: '',
        situation_anterieure_precis: '',
        referent: '',
        conditions1: '',
        conditions1_cv: '',
        conditions2: '',
        conditions2_cv: '',
        proches: [],
      },
      proche: {
        // Empty template proche to add in form.proches. WARNING : when add new field, think to add in this object
        prenom_proche: '',
        nom_proche: '',
        relation_proche: '',
        relation_proche_precis: '',
        adresse_proche: '',
        telephone_proche: '',
        mail_proche: '',
      },
      type_reconnaissance: {
        statut: '',
        statut_cv: '',
        cdaph: '',
        cdaph_validite: '',
        cdaph_cv: '',
      },
      evenements: {
        rqth: '',
        hospitalisation: '',
        demenagement: '',
        mariage: '',
        divorce: '',
        arret_maladie: '',
        reconversion: '',
        autre: '',
      },
    };
  },
  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    await this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_ERRORS: 'neopass/SET_ERRORS',
      calculate_progress: 'neopass/calculate_progress',
    }),

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      if (this.form.prenom === '') {
        this.form.prenom = this.infosPass.firstname;
      }

      if (this.form.nom === '') {
        this.form.nom = this.infosPass.lastname;
      }

      //initialize at least one type de reconnaissance
      if (this.form.type_reconnaissance.length === 0) {
        this.addTypeReconnaissance();
      }

      //initialize at least one proche
      if (this.form.proches.length === 0) {
        this.addProche();
      }
    },

    addTypeReconnaissance() {
      let item = { ...this.type_reconnaissance };
      this.form.type_reconnaissance.push(item);
    },

    addProche() {
      let item = { ...this.proche };
      this.form.proches.push(item);
    },

    deleteItem(el, index) {
      el.splice(index, 1);
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      errors: 'neopass/errors',
    }),
  },
  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
};
</script>
